import React from 'react'
import Car from '../../../assets/iconVoiture.svg'

const ImageCar = () => {
    return (
        <div>
            <img src={Car} alt="" />
        </div>
    )
}

export default ImageCar
